/*eslint perfectionist/sort-objects: "error"*/

export const enGb = {
  account: "Account",
  accountBalance: "Account balance",
  accountDetails: "Account details",
  accountHolder: "Account holder",
  accountHolderName: "Account holder name",
  accountId: "Account ID",
  accountIdentification: "Account identification",
  accountInformation: "Account information",
  accountLegalOwner: "Account legal owner",
  accountLifecycleNotifications: "Account lifecycle notifications",
  accountLifecycleNotificationsSettingsHaveBeenCreated:
    "Account lifecycle notifications settings have been created",
  accountLifecycleNotificationsSettingsHaveBeenUpdated:
    "Account lifecycle notifications settings have been updated",
  accountName: "Account name",
  accountNameHelper: "The friendly name for this trusted beneficiary account",
  accountNotFound: "Account not found",
  accountNumber: "Account number",
  accountNumberAndBsb: "Account number + BSB",
  accountNumberAndBsbHint: "Traditional account number and BSB",
  accountOrderingNotifications: "Account ordering notifications",
  accountOrderingNotificationsSettingsHaveBeenCreated:
    "Account ordering notifications settings have been created",
  accountOrderingNotificationsSettingsHaveBeenUpdated:
    "Account ordering notifications settings have been updated",
  accountOwner: "Account owner",
  accounts: "Accounts",
  accountsHaveBeenSettled: "Accounts have been settled",
  accountStatus: "Account status",
  accountType: "Account type",
  active: "Active",
  addANewRule: "Add a new rule",
  addAnotherOwner: "Add another owner",
  address: "Address",
  addressLine1: "Address line 1",
  addressLine2: "Address line 2",
  addressLine2Optional: "Address line 2 (optional)",
  alias: "Alias",
  aliasAccountNumber: "Alias account number",
  aliasIban: "Alias IBAN",
  aliasSortCode: "Alias sort code",
  aliasSwiftCodeBic: "Alias swift code (BIC)",
  amount: "Amount",
  approved: "Approved",
  areYouSureYouWantToDeactivateThisVirtualIban:
    "Are you sure you want to deactivate this virtual IBAN?",
  areYouSureYouWantToDisableNotifications:
    "Are you sure you want to disable notifications?",
  areYouSureYouWantToSettleAllAccounts:
    "Are you sure you want to settle all accounts?",
  areYouSureYouWantToSettleThisAccount:
    "Are you sure you want to settle this account?",
  availableFunds: "Available funds",
  backToAllAccounts: "Back to all accounts",
  backToBeneficiaries: "Back to beneficiaries",
  balanceAfter: "Balance after",
  balanceCurrency: "Balance ({{currency}})",
  bankAccount: "Bank account",
  bankCode: "Bank code",
  beneficiaries: "Beneficiaries",
  beneficiary: "Beneficiary",
  beneficiaryAccount: "Beneficiary Account",
  beneficiaryAccountTooltip:
    "The trusted beneficiary account where settled funds will be transferred. Only accounts that are active in the Volt system can be selected. If an account becomes inactive after setup, settlements to it will fail.",
  beneficiaryDetails: "Beneficiary details",
  beneficiaryNotFound: "Beneficiary not found",
  bounceBack: "Bounce back",
  bsb: "BSB",
  business: "Business",
  city: "City",
  clearSetupConfirmDescription:
    "This will reset all rules and threshold settings. You'll need to add rules again.",
  clearSetupConfirmOk: "Reset",
  clearSetupConfirmTitle: "Reset schedule setup?",
  closed: "Closed",
  closedAt: "Closed at",
  closedLoopPayout: "Closed loop payout",
  completed: "Completed",
  configuration: "Configuration",
  configureAWebhookToReceiveRealTimeUpdates:
    "Configure a webhook to receive real-time updates on KYC onboarding progress.",
  configureAWebhookToReceiveRealTimeUpdatesOnAccountLifecycleEvents:
    "Configure a webhook to receive real-time updates on account suspension, reactivation, and closure events.",
  configureAWebhookToReceiveRealTimeUpdatesOnAccountOrderingEvents:
    "Configure a webhook to receive real-time updates on named accounts provisioning and alias creation progress.",
  connect: "Connect",
  connected: "Connected",
  connectMatching: "Connect Matching",
  copyFromAccountConfirmDescription:
    "This will replace the current rules and threshold setup. You can add more rules after copying.",
  copyFromAccountConfirmOk: "Copy rules",
  copyFromAccountConfirmTitle: "Overwrite current setup?",
  copyFromAnotherAccount: "Copy from another account (optional)",
  copyToClipboard: "Copy to clipboard",
  country: "Country",
  createBeneficiary: "Create beneficiary",
  created: "Created",
  createdAt: "Created at",
  createdBy: "Created by",
  createdByName: "Created by {{name}}",
  createdViaApi: "Created via API",
  createTrustedBeneficiary: "New trusted beneficiary",
  credit: "Credit",
  currency: "Currency",
  customer: "Customer",
  customerId: "Customer ID",
  daily: "Daily",
  dateWhenTheTransactionWasCreated: "Date when the transaction was created",
  dateWhenTheTransactionWasProcessed: "Date when the transaction was processed",
  dayFewerDaysSettlementTooltip:
    "Days 29–31 may not exist in every month — settlement will run on the last available day at the configured UTC time instead.",
  dayOfMonth: "Day of the month",
  dayOfWeek: "Day of the week",
  deactivate: "Deactivate",
  deactivated: "Deactivated",
  deactivateSettlementSchedule: "Deactivate settlement schedule?",
  deactivateSettlementScheduleDescription:
    "Settlements for <bold>{{accountName}}</bold> will be paused. The configuration is kept so you can reactivate it later without re-entering the rules.",
  deactivateVirtualIban: "Deactivate virtual IBAN",
  disableNotification: "Disable notification",
  duplicateAndOverlappingRulesDescription:
    "We noticed some rules in this schedule are identical — we'll only keep one copy of each. Additionally, some rules are scheduled for the same time, which means only one payment will go out at that time even if multiple rules match. Would you like to save the schedule as is?",
  duplicateRulesDescription:
    "We noticed some rules in this schedule are identical — we'll only save one copy of each.",
  duplicateRulesDetected: "Duplicate rules detected",
  edit: "Edit",
  editBeneficiary: "Edit beneficiary",
  editSettlementSchedule: "Edit settlement schedule",
  email: "Email",
  failed: "Failed",
  firstName: "First name",
  friday: "Friday",
  gatewayPayment: "Gateway payment",
  givenAccountCouldNotBeFound: "Given account could not be found",
  givenBeneficiaryCouldNotBeFound: "Given beneficiary could not be found",
  history: "History",
  iban: "IBAN",
  ignored: "Ignored",
  inactive: "Inactive",
  incoming: "Incoming",
  individual: "Individual",
  inPayout: "In payout",
  inReturn: "In return",
  internal: "Internal",
  internalFx: "FX payout",
  internalPayout: "Internal payout",
  internalReference: "Interactive reference",
  lastName: "Last name",
  leaveWithoutSaving: "Leave without saving",
  legalName: "Legal name",
  local: "Local",
  locationAndCurrency: "Location and currency",
  merchantBeneficiaries: "Merchant beneficiaries",
  minimumThresholdToSettle: "Minimum threshold to settle the account",
  mixedSchedule: "Mixed schedule",
  modification: "{{count}} modification",
  modification_plural: "{{count}} modifications",
  modified: "Modified",
  modifyConfiguration: "Modify configuration",
  monday: "Monday",
  monthly: "Monthly",
  name: "Name",
  namedAccount: "Named account",
  namedAccounts: "Named accounts",
  namedAccountsBeneficiaries: "Named accounts beneficiaries",
  namedAccountsNotifications: "Named accounts notifications",
  namedAccountsNotificationsSettingsHaveBeenCreated:
    "Named accounts onboarding notifications settings have been created",
  namedAccountsNotificationsSettingsHaveBeenUpdated:
    "Named accounts onboarding notifications settings have been updated",
  namedAccountsOnboardingNotifications:
    "Named accounts onboarding notifications",
  noAccounts: "No accounts",
  noAccountsToSettle: "No accounts to settle",
  noAmountToSettle: "No amount to settle",
  noBeneficiaries: "No beneficiaries",
  noPayments: "No payments",
  noSchedule: "No schedule",
  notifications: "Notifications",
  noTransactions: "No transactions",
  noVirtualAccounts: "No virtual accounts",
  noVirtualIBANs: "No virtual IBANs",
  openLoopPayout: "Open loop payout",
  operation: "Operation",
  outgoing: "Outgoing",
  overlappingRulesDescription:
    "Some rules within this schedule overlap. Only one settlement will be executed at the overlapping time. Do you want to continue?",
  overlappingRulesDetected: "Overlapping rules detected",
  own: "Own",
  owner: "Owner",
  paused: "Paused",
  pausedDailySchedule: "Paused — daily schedule",
  pausedMixedSchedule: "Paused — mixed schedule",
  pausedMonthlySchedule: "Paused — monthly schedule",
  pausedWeeklySchedule: "Paused — weekly schedule",
  payId: "PayID",
  payIdHint: "A phone number or email linked to the account",
  payment: "Payment",
  paymentRail: "Payment rail",
  paymentReference: "Payment reference",
  payments: "Payments",
  paymentScheme: "Payment scheme",
  paymentsNotifications: "Payments notifications",
  paymentsNotificationsSettingsHaveBeenCreated:
    "Payments notifications settings have been created",
  paymentsNotificationsSettingsHaveBeenUpdated:
    "{ayments notifications settings have been updated",
  payout: "Payout",
  pending: "Pending",
  pisPayment: "PIS payment",
  pleaseProvideNotificationURL: "Please provide notification URL",
  pleaseProvideValidNotificationURL: "Please provide valid notification URL",
  postalCode: "Postal code",
  processing: "Processing",
  reactivate: "Reactivate",
  reactivateSettlementSchedule: "Reactivate settlement schedule?",
  reactivateSettlementScheduleDescription:
    "Settlements for <bold>{{accountName}}</bold> will be reactivated. The current rule configuration will be applied to all upcoming settlements.",
  recalled: "Recalled",
  received: "Received",
  reference: "Reference",
  refreshAllAccounts: "Refresh all accounts",
  refund: "Refund",
  rejected: "Rejected",
  requestToCreateTrustedBeneficiaryHasBeenGenerated:
    "Request {{humanReadableId}} to create a trusted beneficiary has been generated",
  requestToUpdateTrustedBeneficiaryHasBeenGenerated:
    "Request {{humanReadableId}} to update a trusted beneficiary has been generated",
  retry: "Retry",
  return: "Return",
  returned: "Returned",
  returnedManually: "Returned manually",
  reversal: "Reversal",
  reversed: "Reversed",
  reviewBeforeSaving: "Review before saving",
  routingNumber: "Routing number",
  ruleType: "Rule type",
  saturday: "Saturday",
  saveAnyway: "Save anyway",
  selectAnAccount: "Select an account",
  selectCustomer: "Select customer",
  send: "Send",
  sender: "Sender",
  sepaInstant: "SEPA Instant",
  settleAccount: "Settle account",
  settleAllAccounts: "Settle all accounts",
  settlement: "Settlement",
  settlementAmountNotProvided: "Settlement amount not provided",
  settlementBalance: "Settlement balance",
  settlementOfAllAccounts: "Settlement of all accounts",
  settlementOfThisAccount: "Settlement of this account",
  settlementSchedule: "Settlement schedule",
  settlementScheduleDeactivatedSuccessfully:
    "Settlement schedule has been deactivated",
  settlementScheduleDeactivationFailed:
    "Could not deactivate settlement schedule",
  settlementScheduleReactivatedSuccessfully:
    "Settlement schedule has been reactivated",
  settlementScheduleReactivationFailed:
    "Could not reactivate settlement schedule",
  settlementSchedulerLoadFailed: "Load failed",
  settlementScheduleRule: "RULE {{number}}",
  settlementScheduleSavedSuccessfully: "Settlement schedule has been saved",
  settlementScheduleSaveFailed: "Could not save settlement schedule",
  settlementSkippedBelowThreshold:
    "Settlement is skipped when the account balance is below this amount.",
  settlesDaily: "Settles daily",
  settlesMonthly: "Settles monthly",
  settlesWeekly: "Settles weekly",
  setUpSettlementSchedule: "Set up settlement schedule",
  sortCode: "Sort code",
  state: "State",
  status: "Status",
  statusBeneficiaryActivated: "Active - Payment can be sent to this account",
  statusBeneficiaryDeactivated:
    "Inactive - Payment can't be sent to this account",
  step: "Step",
  subtype: "Subtype",
  sunday: "Sunday",
  suspended: "Suspended",
  swiftCodeBic: "Swift code (BIC)",
  switch: "Switch",
  switchTheEnvironment: "Switch the environment?",
  testNotificationHasBeenSent:
    "Test notification has been sent to {{notificationUrl}}",
  theAmountOfMoneyThatCanBeSettled: "The amount of money that can be settled",
  theseChangesMayImpactCashFlow: "These changes may impact cash flow",
  thisConfigurationAllowsYouToReceiveNotifications:
    "This configuration allows you to receive notifications for all types of payments processed on Volt Accounts, including incoming and outgoing payments.",
  thursday: "Thursday",
  timeUtc: "Time (UTC)",
  topUp: "Top-up",
  toViewAccountsSelectCustomer:
    "To view accounts, please select a customer in the select customer menu in the upper left corner.",
  transactionAmount: "Transaction amount",
  transactionDate: "Transaction date",
  transactionDetails: "Transaction details",
  transactions: "Transactions",
  trustedBeneficiaryCreatedSuccessfully: "Trusted beneficiary has been created",
  trustedBeneficiaryCreationFailed: "Could not create the trusted beneficiary",
  trustedBeneficiaryRequestAlreadyExists:
    "A request to create this trusted beneficiary already exists",
  trustedBeneficiaryUpdatedSuccessfully: "Trusted beneficiary has been updated",
  trustedBeneficiaryUpdateFailed: "Could not update the trusted beneficiary",
  trustedBeneficiaryUpdateRequestAlreadyExists:
    "A request to update this trusted beneficiary already exists",
  tuesday: "Tuesday",
  type: "Type",
  typeOfTransaction: "Type of transaction",
  ultimateBeneficialOwner: "Ultimate beneficial owner",
  ultimateBeneficialOwners: "Ultimate beneficial owners",
  uniqueReference: "Unique reference",
  unknownType: "Unknown Type",
  update: "Update",
  updateTrustedBeneficiary: "Update trusted beneficiary",
  valueDate: "Value date",
  vIBANused: "vIBAN used",
  viewDetails: "View details",
  virtualAccount: "Virtual account",
  virtualAccounts: "Virtual accounts",
  virtualIBANHasBeenDeactivatedSuccessfully:
    "Virtual IBAN has been deactivated successfully",
  virtualIBANs: "Virtual IBANs",
  volt: "Volt",
  voltAccount: "Volt account",
  voltAccounts: "Volt accounts",
  voltId: "Volt ID",
  voltPayoutId: "Volt payout ID",
  voltRefundId: "Volt refund ID",
  voltSettlementId: "Volt settlement ID",
  voltVirtualIBANIdentifierUsedForReconciliation:
    "Volt Virtual IBAN identifier used for reconciliation of credits",
  waiting: "Waiting",
  wednesday: "Wednesday",
  weekly: "Weekly",
  weHaveSettledYourAccount: "We have settled your account",
  withdrawal: "Withdrawal",
  workflowsAreAvailableOnlyOnProduction:
    "Workflows are available only on Production environment. Would you like to switch the environment?",
  youDontHaveAnyAccountsYet: "You don't have any accounts yet.",
  youDontHaveAnyBeneficiariesYet: "You don't have any beneficiaries yet.",
  youDontHaveAnyPaymentsThatMatchTheCriteria:
    "You don't have any payments that match the criteria.",
  youDontHaveAnyPaymentsYet: "You don't have any payments yet.",
  youDontHaveAnyTransactionsYet: "You don't have any transactions yet.",
  youDontHaveAnyVIBANsYet: "You don't have any virtual IBANs yet.",
  youDontHaveAnyVirtualAccountsYet: "You don't have any virtual accounts yet.",
};
